import { Component, OnInit, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { SecurityContext } from '@angular/core';

@Component({
  selector: 'app-button-round',
  templateUrl: './button-round.component.html',
  styleUrls: ['./button-round.component.css']
})
export class ButtonRoundComponent implements OnInit {
  @Input() label: string = "Energiefluss";
  @Input() icon: string = "Energiefluss";
  @Input() index: number = 0;
  @Input() vehicleActive: boolean = false;
  offset: string = "0px";
  active: boolean = false;

  sanitized;

  constructor(private _sanitizer: DomSanitizer){ }
  
  ngOnInit() {
    this.sanitized = this._sanitizer.sanitize(SecurityContext.HTML, this.label);
    if(this.index == 1){
      this.offset = "-30px";
    }
    if(this.index == 2){
      this.offset ="-8px";
    }
    if(this.index == -1){
      this.offset = "60px";
    }
    if(this.index == -2){
      this.offset ="38px";
    }
    if(this.index < -2){
      this.offset ="18px";
    }

  }

}



// WEBPACK FOOTER //
// ./src/app/button-round/button-round.component.ts